// @ts-nocheck
import React, { useEffect } from 'react';
import PtlSignupView from './view';
import PtlSignupProvider from './state';
import AppMediaProvider from 'baseStyles/AppMediaProvider';
import { HoneyPotInput } from 'schoolUiComponents/HoneyPotInput';
import Button from 'schoolUiComponents/basic/Button';
import Text from 'schoolUiComponents/basic/Text';
import { initGlobalCachePrevention } from '../utils/preventBrowserCache';

interface IPtlSignupProps {
}

const PtlSignup: React.FC<IPtlSignupProps> = () => {
    useEffect(() => {
        let rightHeader : any = document.querySelectorAll(".right.main-nav")?.[0]
        if(rightHeader){
          rightHeader.style.display = "none"
        }
    
        return () => {
          if(rightHeader){
            rightHeader.style.display = "block"
          }
        };
      }, []);

      return (
        <AppMediaProvider>
            <PtlSignupProvider>
                <HoneyPotInput>
                  <PtlSignupView />
                </HoneyPotInput>
            </PtlSignupProvider>
        </AppMediaProvider>
    )
}

// Initialize global cache prevention
initGlobalCachePrevention();

const container = document.getElementById('ptl-signup-container-wrap');
const logoutButtonContainer = document.querySelector('#main_splashmath_header>#header>.container');

if (container) {
    import('react-dom/client').then(({ createRoot }) => {
        const root = createRoot(container);
        root.render(<PtlSignup />);

        if(window.isLoggedInUser && logoutButtonContainer) {
          const div = document.createElement("div");
          logoutButtonContainer.appendChild(div);
          const logoutRoot = createRoot(div);
          logoutRoot?.render(<Button onClick={() => {
            window.location.replace("/signout");
          }} width='104px' height='38px' bordered><Text emphasis cta noUnderline>Logout</Text></Button>)
        }
    })
}

export default PtlSignup;